(function () {
  'use strict';

  // Variáveis
  const $formBusca = $('#form-busca-restaurar');
  const $formRestaurar = $('#form-restaurar');
  const $btnBusca = $('.btn-busca-pedidos-dsers');
  const $tabelaPedidos = $('#table-pedidos');
  const $tabelaPedidosList = $tabelaPedidos.find('tbody');
  const $selectAll = $('#select-all2');
  let buscando = false;

  // Informações para paginação
  $formRestaurar.data('buscados', 0);
  $formRestaurar.data('p', 1);
  $formRestaurar.data('realizou_busca_inicial', false);
  var total_registros = 50; // Total de registros para buscar na paginação

  const htmlLinhaBuscar = () => `
  <tr class="linha-buscar-mais">
    <td colspan="5" style="text-align: center;">
      <button class="btn btn-primary btn-buscar-mais" type="button"><i class="las la-spinner"></i> Carregar mais</button>
    </td>
  </tr>
  `;

  const htmlLinhaLoad = () => `
  <tr class="linha-load">
    <td colspan="5" class="p-0">
      <div class="loader-el-wrp active" style="height: 62px; min-height: unset;">
        <div class="loader-container">
          <div class="loader-wrapper">
            <div class="loader"></div>
          </div>
        </div>
      </div>
    </td>
  </tr>`;

  // Evento ao enviar o formulário de busca de pedidos
  $formBusca.on('submit', function (ev) {
    ev.preventDefault();
    resetaPaginacao();
    resetaTotalBuscados();
    buscaPedidos(true, total_registros, true);
  });

  $formRestaurar.on('submit', function (ev) {
    ev.preventDefault();
    restaurarPedidos();
  });

  // Ação executada quando o reset de produtos é executado
  function restaurarPedidos() {
    const dados = $formRestaurar.serialize();
    const url = $formRestaurar.attr('action');
    showLoader();
    $.post(
      url,
      dados,
      function (result) {
        // Sucesso
        if (result.status == 'success') {
          hideLoader();

          const $rowsTabelaPedidos = $tabelaPedidos.find('tr');
          $rowsTabelaPedidos.has('input:checked').remove();

          Toast.fire({
            type: 'success',
            title: 'Pedidos restaurados com sucesso.',
          });
        }
        // Erro
        else {
          hideLoader();
          Toast.fire({
            type: 'error',
            title: 'Não foi possível restaurar os pedidos.',
          });
        }
      },
      'json',
    );
  }

  // Ação executada quando o mordal é aberto
  $('#modal-restaurar-pedidos').on('show.bs.modal', function (e) {
    if ($formRestaurar.data('realizou_busca_inicial') == false) {
      buscaPedidos(true, total_registros);
      $formRestaurar.data('realizou_busca_inicial', true);
    }
  });

  // Ação executada enquanto a busca de pedidos é realizada
  function beforeBuscaPedidos() {
    buscando = true;
    // $tabelaPedidosList.html('');
    $tabelaPedidosList.append(htmlLinhaLoad());
    // $tabelaPedidosList.html(htmlLinhaLoad());
    $btnBusca.prop('disabled', true).html('<div class="btn-spinner dark"></div> Buscando');
    hideBtnsDownDSers();
  }

  // Ação executada quando a busca de pedidos é finalizada
  function resetBuscaPedidos() {
    buscando = false;
    $selectAll.parent('.form-check').addClass('d-none');
    $selectAll.prop('checked', false).trigger('change');
    $btnBusca.prop('disabled', false).html('<i class="las la-search mr-2"></i>Buscar Pedidos');
  }

  // Busca os pedidos que serão exportados
  function buscaPedidos(paginacao = false, registros = 0, limpa_tabela = true) {
    if (!buscando) {
      beforeBuscaPedidos();
      const dados = $formBusca.serializeArray();
      if (paginacao) {
        dados.push(
          ...[
            {
              name: 'paginacao',
              value: true,
            },
            {
              name: 'registros',
              value: registros,
            },
            {
              name: 'p',
              value: getPagina(),
            },
          ],
        );
      }
      // const url = $formBusca.attr('action') + '?' + dados;
      const url = $formBusca.attr('action');

      $.getJSON(url, dados, function (result) {
        // Sucesso
        if (result.status == 'success') {
          resetBuscaPedidos();
          populaPedidos(result, limpa_tabela);
          if (paginacao) {
            afterBuscaPaginacao(registros, result);
          } else {
            resetaTotalBuscados();
            resetaPaginacao();
          }
        }
        // Erro
        else {
          resetBuscaPedidos();
          Toast.fire({
            type: 'error',
            title: 'Não foi possível carregar os pedidos',
          });
        }
        afterBuscaPedidos();
      });
    }
  }

  $tabelaPedidos.on('click', '.btn-buscar-mais', btnBuscarMaisClick);
  function btnBuscarMaisClick(e) {
    buscaPedidos(true, total_registros, false);
    $tabelaPedidosList.find('.linha-buscar-mais').remove();
    // $tabelaPedidosList.append(htmlLinhaLoad());
  }

  function afterBuscaPaginacao(registros, result) {
    $tabelaPedidosList.find('.linha-buscar-mais')?.remove();
    somaBuscados(registros);
    somaPaginacao();
    if (result.total > totalBuscados()) {
      $tabelaPedidosList.append(htmlLinhaBuscar());
    }
  }

  function somaPaginacao() {
    var pagina = getPagina();
    pagina = Number(pagina) + 1;
    $formRestaurar.data('p', pagina);
  }

  function resetaPaginacao() {
    $formRestaurar.data('p', 1);
  }

  function getPagina() {
    return Number($formRestaurar.data('p'));
  }

  function afterBuscaPedidos() {
    $tabelaPedidosList.find('.linha-load')?.remove();
  }

  function resetaTotalBuscados(qtd) {
    $formRestaurar.data('buscados', 0);
  }

  function somaBuscados(qtd) {
    var buscados = totalBuscados();
    $formRestaurar.data('buscados', buscados + qtd);
  }

  function totalBuscados() {
    return Number($formRestaurar.data('buscados'));
  }

  // Popula os pedidos na lista
  function populaPedidos(result, limpa_tabela = true) {
    if (limpa_tabela) {
      $tabelaPedidosList.html('');
    }
    $('#select-all2').prop('checked', true);
    if (result.total > 0) {
      result.pedidos.forEach((pedido) => {
        let data_hora = pedido.creat_at.split(' ');
        let data_creat_at = data_hora[0].split('-');
        let str_data = `${data_creat_at[2]}/${data_creat_at[1]}/${data_creat_at[0]}`;
        let str_hora = data_hora[1].split(':');
        str_hora = `${str_hora[0]}:${str_hora[1]}`;

        pedido.status.event = pedido.status.event == 'order_created' ? 'awaiting_payment' : pedido.status.event;

        $tabelaPedidosList.append(`
        <tr data-row="${pedido.id}">
          <td>
            <div class="form-check mb-2 mb-md-0">
              <input type="checkbox" name="pedidos[]" id="check2-row-${pedido.id}" class="check-row" value="${
          pedido.id
        }">
              <label for="check2-row-${pedido.id}" title="Selecionar item"><span>Selecionar</span></label>
            </div>
          </td>
          <td data-label="Pedido:">
            <a href="${result.urlUpdPermission}${pedido.id}" class="link"><b>#${pedido.token}</b></a><br>
            <div style="max-width: 220px;">
              <div class="truncate-text">${pedido.customer_name}</div>
            </div>
          </td>
          <td data-label="Data:">
            <b>${str_data}</b><br>
            às
            <b>${str_hora}</b>
          </td>
          <td data-label="Valor:">R$ ${formatMoneyBR(pedido.payment_subtotal)}</td>
          <td data-label="Status:">
            <span style="display: table-caption;" class="badge badge-pill ${
              result.configOrderStatus[pedido.status.event]['class']
            }"data-toggle="tooltip" data-placement="bottom" title="${
          result.configOrderStatus[pedido.status.event]['desc']
        }">${result.configOrderStatus[pedido.status.event]['title']}</span>
          </td>
        </tr>`);
      });
      $selectAll.parent('.form-check').removeClass('d-none');
      $selectAll.prop('checked', true).trigger('change');
    } else {
      $tabelaPedidosList.append('<td colspan="5" class="text-center">Nenhum pedido encontrado.</td>');
    }
    $formRestaurar.find('input[name="ids"]').parsley().reset();
    initTooltips();
  }
})();

// Exibe os botões para download (DSers)
function showBtnsDownDSers(result) {
  //console.log(result);
  const $btnsDownload = $('#exporta-btns');
  const $btnDownloadProds = $btnsDownload.find('.btn-produtos');
  const $btnDownloadPedidos = $btnsDownload.find('.btn-pedidos');
  $btnsDownload.removeClass('d-none');
  $btnDownloadProds.attr('href', result.arquivos.produtos);
  $btnDownloadPedidos.attr('href', result.arquivos.pedidos);
}

// Oculta os botões para download (DSers)
function hideBtnsDownDSers() {
  const $btnsDownload = $('#exporta-btns');
  const $btnDownloadProds = $btnsDownload.find('.btn-produtos');
  const $btnDownloadPedidos = $btnsDownload.find('.btn-pedidos');
  $btnsDownload.addClass('d-none');
  $btnDownloadProds.attr('href', '#');
  $btnDownloadPedidos.attr('href', '#');
}
